/*!
 *   Copyright 2022-2025 SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

@import "../../scss/vars";

:host {
  width: 100%;
  height: 100%;

  .button-wrapper {
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;

    button.discovery-btn {
      position: relative;
      margin: .25rem .125rem;
      display: inline-block;
      font-weight: 400;
      line-height: 1.5;
      text-align: center;
      text-decoration: none;
      vertical-align: middle;
      cursor: pointer;
      font-size: var(--warp-view-button-font-size, 1rem);
      border: 1px solid var(--warp-view-button-border-color, $w10-blue);
      padding: var(--warp-view-button-padding, .375rem .75rem);
      color: var(--warp-view-button-label-color, $w10-white);
      background-color: var(--warp-view-button-bg-color, $w10-blue);
      min-width: var(--warp-view-button-width, auto);
      border-radius: var(--warp-view-button-border-radius, 0.25rem);

      &.button--start {
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;

        &.button--loading::before {
          left: unset !important;
          right: var(--warp-view-button-padding, .375rem) !important;
        }
      }

      &.button--end {
        display: flex;
        flex-direction: row;
        justify-content: end;
        align-items: center;

        &.button--loading::before {
          right: unset !important;
          left: var(--warp-view-button-padding, .375rem) !important;
        }
      }

      &.button--center {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }
    }

    button:disabled {
      background-color: var(--warp-view-button-bg-disabled-color, $w10-lightgrey);;
      border: 1px solid var(--warp-view-button-disabled-border-color, $w10-grey);
    }
  }

  .button--loading::before {
    content: "";
    position: absolute;
    width: var(--warp-view-button-font-size, 1rem);
    height: var(--warp-view-button-font-size, 1rem);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border: 4px solid transparent;
    border-top-color: currentColor;
    border-radius: 50%;
    animation: button-loading-spinner 1s ease infinite;
  }

  .discovery-btn-radio {
    button.discovery-btn {
      position: relative;
      margin: .25rem 0;
      color: var(--warp-view-button-inactive-label-color, $w10-blue);
      background-color: var(--warp-view-button-inactive-bg-color, $w10-white);

      &.active {
        color: var(--warp-view-button-label-color, $w10-white);
        background-color: var(--warp-view-button-bg-color, $w10-blue);
      }

      &:hover {
        color: var(--warp-view-button-label-color, $w10-white);
        background-color: var(--warp-view-button-bg-color, $w10-blue);
      }

      &:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }

      &:not(:first-of-type) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
  }

  .discovery-btn-group {
    display: flex;
    align-items: center;
    justify-content: center;

    &.discovery-btn-group-v {
      flex-direction: column;
    }

    &.discovery-btn-group-h {
      flex-direction: row;

      button.button--loading::before {
        content: "";
        position: absolute;
        width: var(--warp-view-button-font-size, 1rem);
        height: var(--warp-view-button-font-size, 1rem);
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        border: 4px solid transparent;
        border-top-color: currentColor;
        border-radius: 50%;
        animation: button-loading-spinner 1s ease infinite;
      }
    }
  }

  .discovery-btn-radio {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @keyframes button-loading-spinner {
    from {
      transform: rotate(0turn);
    }

    to {
      transform: rotate(1turn);
    }
  }

}
